<template>
    <p v-if="errorText" class="form-error ml-1" ref="errorEl">
        {{ errorText }}
    </p>
</template>
<script lang="ts" setup>
import { computed, watch, ref, nextTick } from 'vue'

export type FormErrorType = string | string[]

const props = defineProps<{
    error?: FormErrorType
}>()

const errorEl = ref<HTMLElement | null>(null)

const errorText = computed(() => {
    if (!props.error) {
        return null
    }
    if (Array.isArray(props.error) && props.error.length > 0) {
        return props.error[0]
    }
    return props.error
})

watch(
    () => props.error,
    (newValue, oldValue) => {
        if (newValue && newValue !== oldValue) {
            nextTick(() => {
                errorEl.value?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center',
                })
            })
        }
    },
)
</script>
